
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-16 px-6 md:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 text-center">
          <div>
            <h3 className="text-2xl font-bold mb-6 tracking-[0.3em]">MILAN</h3>
          </div>
          
          <div>
            <h4 className="text-lg font-medium mb-6 tracking-wide">Contact</h4>
            <div className="space-y-2 text-gray-400 text-sm">
              <p>JAPAN </p>
              <p>Via della Moda 123</p>
              <p>+39 02 1234 5678</p>
              <p>info@milan-fashion.com</p>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-medium mb-6 tracking-wide">Follow Us</h4>
            <div className="flex space-x-4 justify-center">
              <a 
                href="https://www.instagram.com/milan_official_online/" 
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors"
              >
                <i className="ri-facebook-line text-lg"></i>
              </a>
              <a 
                href="https://www.threads.com/@milan_official_online?xmt=AQF001lQwnSB6nsMeupGmn7dL46Zm3bIYyf2qaHMCMYim2g" 
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-500">
          <p>&copy; 2024 MILAN. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
